import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DoctorsService} from '../../services/doctors/doctors.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-medici-detail',
  templateUrl: './medici-detail.component.html',
  styleUrls: ['./medici-detail.component.scss']
})
export class MediciDetailComponent implements OnInit {

    doctor: any;
    endpoint: any;

  constructor(
      private doctorsService: DoctorsService,
      private route: ActivatedRoute
  ) {
      const t = this;
      t.endpoint = environment.endpoint;
      if (this.route.snapshot.paramMap.get('friendlyUrl')) {
          this.doctorsService.find(this.route.snapshot.paramMap.get('friendlyUrl')).subscribe((data: any) => {
              t.doctor = data;
          });
      }
  }

    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }

  ngOnInit(): void {
  }

}
